import { defineComponent as V, ref as E, computed as u, toRaw as c, provide as W, onMounted as N, watch as _, h as F, Fragment as M, onUnmounted as U, inject as J } from "vue";
import { useControllable as q } from "./index325.js";
import { useId as C } from "./index327.js";
import { useTreeWalker as z } from "./index331.js";
import { Hidden as Q, Features as X } from "./index332.js";
import { Keys as R } from "./index334.js";
import { dom as S } from "./index339.js";
import { sortByDomNode as Y, focusIn as L, Focus as O, FocusResult as P } from "./index340.js";
import { objectToFormEntries as Z, attemptSubmit as ee } from "./index341.js";
import { getOwnerDocument as w } from "./index343.js";
import { compact as ae, render as D, omit as re } from "./index345.js";
import { useDescriptions as B } from "./index353.js";
import { Label as te, useLabels as I } from "./index358.js";
function le(a, v) {
  return a === v;
}
let j = Symbol("RadioGroupContext");
function x(a) {
  let v = J(j, null);
  if (v === null) {
    let b = new Error(`<${a} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(b, x), b;
  }
  return v;
}
let Re = V({ name: "RadioGroup", emits: { "update:modelValue": (a) => !0 }, props: { as: { type: [Object, String], default: "div" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => le }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(a, { emit: v, attrs: b, slots: k, expose: h }) {
  var g;
  let n = (g = a.id) != null ? g : `headlessui-radiogroup-${C()}`, s = E(null), o = E([]), y = I({ name: "RadioGroupLabel" }), $ = B({ name: "RadioGroupDescription" });
  h({ el: s, $el: s });
  let [p, G] = q(u(() => a.modelValue), (e) => v("update:modelValue", e), u(() => a.defaultValue)), d = { options: o, value: p, disabled: u(() => a.disabled), firstOption: u(() => o.value.find((e) => !e.propsRef.disabled)), containsCheckedOption: u(() => o.value.some((e) => d.compare(c(e.propsRef.value), c(a.modelValue)))), compare(e, t) {
    if (typeof a.by == "string") {
      let r = a.by;
      return e?.[r] === t?.[r];
    }
    return a.by(e, t);
  }, change(e) {
    var t;
    if (a.disabled || d.compare(c(p.value), c(e))) return !1;
    let r = (t = o.value.find((i) => d.compare(c(i.propsRef.value), c(e)))) == null ? void 0 : t.propsRef;
    return r != null && r.disabled ? !1 : (G(e), !0);
  }, registerOption(e) {
    o.value.push(e), o.value = Y(o.value, (t) => t.element);
  }, unregisterOption(e) {
    let t = o.value.findIndex((r) => r.id === e);
    t !== -1 && o.value.splice(t, 1);
  } };
  W(j, d), z({ container: u(() => S(s)), accept(e) {
    return e.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(e) {
    e.setAttribute("role", "none");
  } });
  function m(e) {
    if (!s.value || !s.value.contains(e.target)) return;
    let t = o.value.filter((r) => r.propsRef.disabled === !1).map((r) => r.element);
    switch (e.key) {
      case R.Enter:
        ee(e.currentTarget);
        break;
      case R.ArrowLeft:
      case R.ArrowUp:
        if (e.preventDefault(), e.stopPropagation(), L(t, O.Previous | O.WrapAround) === P.Success) {
          let r = o.value.find((i) => {
            var l;
            return i.element === ((l = w(s)) == null ? void 0 : l.activeElement);
          });
          r && d.change(r.propsRef.value);
        }
        break;
      case R.ArrowRight:
      case R.ArrowDown:
        if (e.preventDefault(), e.stopPropagation(), L(t, O.Next | O.WrapAround) === P.Success) {
          let r = o.value.find((i) => {
            var l;
            return i.element === ((l = w(i.element)) == null ? void 0 : l.activeElement);
          });
          r && d.change(r.propsRef.value);
        }
        break;
      case R.Space:
        {
          e.preventDefault(), e.stopPropagation();
          let r = o.value.find((i) => {
            var l;
            return i.element === ((l = w(i.element)) == null ? void 0 : l.activeElement);
          });
          r && d.change(r.propsRef.value);
        }
        break;
    }
  }
  let f = u(() => {
    var e;
    return (e = S(s)) == null ? void 0 : e.closest("form");
  });
  return N(() => {
    _([f], () => {
      if (!f.value || a.defaultValue === void 0) return;
      function e() {
        d.change(a.defaultValue);
      }
      return f.value.addEventListener("reset", e), () => {
        var t;
        (t = f.value) == null || t.removeEventListener("reset", e);
      };
    }, { immediate: !0 });
  }), () => {
    let { disabled: e, name: t, form: r, ...i } = a, l = { ref: s, id: n, role: "radiogroup", "aria-labelledby": y.value, "aria-describedby": $.value, onKeydown: m };
    return F(M, [...t != null && p.value != null ? Z({ [t]: p.value }).map(([A, T]) => F(Q, ae({ features: X.Hidden, key: A, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: r, disabled: e, name: A, value: T }))) : [], D({ ourProps: l, theirProps: { ...b, ...re(i, ["modelValue", "defaultValue", "by"]) }, slot: {}, attrs: b, slots: k, name: "RadioGroup" })]);
  };
} });
var oe = ((a) => (a[a.Empty = 1] = "Empty", a[a.Active = 2] = "Active", a))(oe || {});
let he = V({ name: "RadioGroupOption", props: { as: { type: [Object, String], default: "div" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(a, { attrs: v, slots: b, expose: k }) {
  var h;
  let g = (h = a.id) != null ? h : `headlessui-radiogroup-option-${C()}`, n = x("RadioGroupOption"), s = I({ name: "RadioGroupLabel" }), o = B({ name: "RadioGroupDescription" }), y = E(null), $ = u(() => ({ value: a.value, disabled: a.disabled })), p = E(1);
  k({ el: y, $el: y });
  let G = u(() => S(y));
  N(() => n.registerOption({ id: g, element: G, propsRef: $ })), U(() => n.unregisterOption(g));
  let d = u(() => {
    var l;
    return ((l = n.firstOption.value) == null ? void 0 : l.id) === g;
  }), m = u(() => n.disabled.value || a.disabled), f = u(() => n.compare(c(n.value.value), c(a.value))), e = u(() => m.value ? -1 : f.value || !n.containsCheckedOption.value && d.value ? 0 : -1);
  function t() {
    var l;
    n.change(a.value) && (p.value |= 2, (l = S(y)) == null || l.focus());
  }
  function r() {
    p.value |= 2;
  }
  function i() {
    p.value &= -3;
  }
  return () => {
    let { value: l, disabled: A, ...T } = a, K = { checked: f.value, disabled: m.value, active: !!(p.value & 2) }, H = { id: g, ref: y, role: "radio", "aria-checked": f.value ? "true" : "false", "aria-labelledby": s.value, "aria-describedby": o.value, "aria-disabled": m.value ? !0 : void 0, tabIndex: e.value, onClick: m.value ? void 0 : t, onFocus: m.value ? void 0 : r, onBlur: m.value ? void 0 : i };
    return D({ ourProps: H, theirProps: T, slot: K, attrs: v, slots: b, name: "RadioGroupOption" });
  };
} }), Oe = te;
export {
  Re as RadioGroup,
  Oe as RadioGroupLabel,
  he as RadioGroupOption
};
